module.exports = __webpack_public_path__ + "img/95.7.Chla.cf7ccede.png";